// cSpell:ignore bewoond dagen leeg Leegstand Prorata
// The days a lease ran of a cost's period (Lewis, 2026-10-19): the cost
// drawer's cell reads only the ratio, "245/365", in the style of the unit's
// share ("55/85") and on one line; its hover says it in full, "245 van de
// 365 dagen bewoond (01/01/2026 – 31/12/2026)". The days an owner's unit
// stood empty read the same way, "30/365" with "30 van de 365 dagen leeg
// (…)" in its hover: the row (the drawer's "Leegstand" under "Prorata")
// says which days they are. The "i" of a summary row's amount names them
// after its label, "Prorata: 245/365 dagen (01/01/2026 – 31/12/2026)".

import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { costDayText } from "./costPeriod.utils";

export interface IOccupiedDays {
  days: number;
  // The days of the cost's period.
  total: number;
  // The cost's period, for the hover; left out of it when unknown.
  period?: { from: string; to: string };
  // The days the unit stood empty, the owner's.
  isVacant?: boolean;
}

const dayValues = (occupied: IOccupiedDays) => ({
  days: String(occupied.days),
  total: String(occupied.total),
});

// "245/365".
export const occupiedDaysRatio = (occupied: IOccupiedDays): string =>
  `${occupied.days}/${occupied.total}`;

// The text with the cost's period after it, when known.
const withPeriod = (text: string, occupied: IOccupiedDays): string => {
  const { period } = occupied;
  return period
    ? `${text} (${costDayText(period.from)} – ${costDayText(period.to)})`
    : text;
};

// "245 van de 365 dagen bewoond (01/01/2026 – 31/12/2026)", or "30 van de
// 365 dagen leeg (…)".
export const occupiedDaysSentence = (occupied: IOccupiedDays): string =>
  withPeriod(
    getLocalizedText(
      occupied.isVacant
        ? "settlement.summary.card.days_vacant_full"
        : "settlement.summary.card.days_occupied_full",
      dayValues(occupied),
    ),
    occupied,
  );

// "245/365 dagen (01/01/2026 – 31/12/2026)": the "i" of a summary row's
// amount, after "Prorata" or "Leegstand" (Lewis, 2026-10-19).
export const occupiedDaysText = (occupied: IOccupiedDays): string =>
  withPeriod(
    getLocalizedText("settlement.summary.card.days_ratio", dayValues(occupied)),
    occupied,
  );
